import React from 'react';
import {Col, Row} from 'antd';
import PersonalInfoCard from '../../../member/accounts/contactInfo/PersonalInfoCard';
import PhoneNumbersCard from '../../../../components/contactMethod/PhoneNumbersCard';
import DriverLicenceCard from '../../../../components/driverLicence/DriverLicenceCard';
import AddressCard from '../../../../components/contactMethod/AddressCard';
import './ContactInfoPage.less';

const ContactInfoPage = () => {
    return (
        <Row gutter={16} className="contact-info-page">
            <Col className="cards-grid-column col-height-responsive">
                <PersonalInfoCard/>
            </Col>
            <Col className="cards-grid-column col-height-responsive">
                <PhoneNumbersCard/>
                <DriverLicenceCard/>
            </Col>
            <Col className="cards-grid-column">
                <AddressCard contactableType="profile"/>
            </Col>
        </Row>
    );
}

export default ContactInfoPage;
